import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { getUser } from '../../../reducers'
import { Col, Grid, Row } from 'react-flexbox-grid'
import { Button, Divider, message } from 'antd'
import FormOutsourcing from '../../containers/FormOutsourcing'
import { firestore } from '../../../config/Fire'
import * as Constants from '../../../constants'
import LoadingPage from '../../components/LoadingPage'
import './styles.css'

const DetailsOutsourcing = props => {
    const [updatingOutsourcing, setUpdatingOutsourcing] = useState(false)
    const [detailsOutsourcing, setDetailsOutsourcing] = useState(null)

    useEffect(() => {
        if (props.outsourcingToEdit) {
            setDetailsOutsourcing(props.outsourcingToEdit)
        }
    }, [props.outsourcingToEdit])

    const updateOutsourcing = async outsourcingProp => {
        if (outsourcingProp && detailsOutsourcing && detailsOutsourcing.id) {
            setUpdatingOutsourcing(true)
            const outsourcingToUpdate = { ...outsourcingProp }
            firestore.collection(Constants.MAIN_NODES.OUTSOURCING_ORDERS).doc(detailsOutsourcing.id).update(outsourcingToUpdate)
                .then(() => {
                    setUpdatingOutsourcing(false)
                    message.success('¡El proveedor se editó exitósamente!')
                    props.onUpdateBidOrder(outsourcingToUpdate)
                })
                .catch(err => {
                    setUpdatingOutsourcing(false)
                    console.log(err)
                })
        }
    }

    return (
        <Grid className="newOutsourcingCont">
            {
                detailsOutsourcing ?
                    <div>
                        <Row center="xs">
                            <Col xs={12}>
                                <h2>Edición - Proveedor</h2>
                            </Col>
                        </Row>
                        <Divider/>
                        <Row center="xs">
                            <Col xs={12}>
                                <FormOutsourcing
                                    isEditing={true}
                                    outsourcingToEdit={detailsOutsourcing}
                                    onSubmitOutsourcing={updateOutsourcing}
                                    loading={updatingOutsourcing}
                                />
                            </Col>
                        </Row>
                        <Row center="xs">
                            <Col xs={6}>
                                <Button onClick={() => props.onBack(false, null)} loading={updatingOutsourcing}>
                                    Salir
                                </Button>
                            </Col>
                        </Row>
                    </div>
                    :
                    <LoadingPage/>
            }
        </Grid>
    )
}

DetailsOutsourcing.propTypes = {}

const mapDispatchToPropsActions = dispatch => ({})

const mapStateToProps = state => ({
    user: getUser(state)
})

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(DetailsOutsourcing))